import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpClientModule,
  HttpHeaders,
} from "@angular/common/http";
import { environment } from "../../../environment/environment";
import { interval, Subscription, switchMap, takeWhile } from "rxjs";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class AuthenticationService {
  httpOptions: any;

  //for status checking api
  private statusCheckSubscription!: Subscription;
  private isUserLoggedIn = true; // Flag to track login state
  constructor(private httpClient: HttpClient,
    private router: Router
  ) {
    this.startUserStatusCheck();
  }

  login(FormDetails: any) {
    return this.httpClient.post<boolean>(
      environment.url + "/customers/auth/login/customer-login",
      FormDetails
    );
  }
  sendOTPForChangePassord(FormDetails: any) {
    return this.httpClient.post<boolean>(
      environment.url + "/customers/auth/login/sendOTPForChangePassword",
      FormDetails
    );
  }
  verifyOTPForChangePassord(FormDetails: any) {
    return this.httpClient.post<boolean>(
      environment.url + "/customers/auth/login/verifyOTPForChangePassword",
      FormDetails
    );
  }

  changePassord(FormDetails: any) {
    return this.httpClient.post<boolean>(
      environment.url + "/customers/auth/login/changePassword",
      FormDetails
    );
  }
  
  startUserStatusCheck() {
    this.isUserLoggedIn = true;;
    const userType = localStorage.getItem('userType'); // "customer" or "customerContact"
    const userId = localStorage.getItem('user_id');

    if (!userType || !userId) {
      this.logoutUserIfStatusZero(); // If no valid session, logout immediately
      return;
    }

    this.statusCheckSubscription = interval(30000) // Check every 30 seconds
      .pipe(
        takeWhile(() => this.isUserLoggedIn), // Stop checking if logged out
        switchMap(() =>
          this.httpClient.post<{ status: number }>(environment.url + "/customers/auth/login/checkCustomerStatus", { userType, id: userId })
        )
      )
      .subscribe({
        next: (res:any) => {
          if(res.code == 1){
            if (res.data.status == 0) {
              this.logoutUserIfStatusZero();
            }
          }
        },
        error: (err) => {
          console.error('Error checking user status:', err);
        },
      });
  }

  logoutUserIfStatusZero() {
    this.isUserLoggedIn = false; // Prevent further API calls
    if (this.statusCheckSubscription) {
      this.statusCheckSubscription.unsubscribe(); // Stop the API calls after logout
    }
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  logoutUser() {
    this.isUserLoggedIn = false; // Stop further API calls
  
    if (this.statusCheckSubscription) {
      this.statusCheckSubscription.unsubscribe(); // ✅ Stop interval from running
    }
  }

  onReloadUserStatusCheck() {
    this.isUserLoggedIn = true;;
    const userType = localStorage.getItem('userType'); // "customer" or "customerContact"
    const userId = localStorage.getItem('user_id');

    if (!userType || !userId) {
      this.logoutUserIfStatusZero(); // If no valid session, logout immediately
      return;
    }
    this.httpClient.post<{ status: number }>(environment.url + "/customers/auth/login/checkCustomerStatus", { userType, id: userId })
      .subscribe({
        next: (res:any) => {
          if(res.code == 1){
            if (res.data.status == 0) {
              this.logoutUserIfStatusZero();
            }
          }
        },
        error: (err) => {
          console.error('Error checking user status:', err);
        },
      });
  }
  
}
